import React, { useEffect } from "react";
import { Box, Typography, Button } from "@mui/material";
import { FaLongArrowAltLeft, FaExclamationCircle } from "react-icons/fa"; // Using an exclamation icon
import { useNavigate, useLocation } from "react-router-dom";  // Import useLocation
import AOS from "aos";
import "aos/dist/aos.css"; // Import AOS styles
import "./NotFound.scss"; // Import the SCSS for animations
import { useLanguage } from "../../context/LanguageContext/LanguageContext";
const NotFound = ({ message  }) => {
  const navigate = useNavigate();
    const { translations, language, direction } = useLanguage();
      const t = translations;
  const location = useLocation(); 
  
  useEffect(() => {
    // Initialize AOS animation
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <Box
      data-aos="fade-up" // AOS animation trigger
      sx={{ textAlign: "center", padding: "100px 20px", backgroundColor: "#f8fafb" }}
    >
      <FaExclamationCircle
        className="not-found-icon" // Add class to the icon for spinning animation
        style={{ fontSize: "60px", color: "#12538B", marginBottom: "16px" }}
      />
      <Typography variant="h4" sx={{ fontWeight: 600, color: "#12538B", mb: 2 }}>
        {message}
      </Typography>
      <Typography variant="body1" sx={{ color: "#676464", mb: 4 }}>
      {t.notfound}
      </Typography>
      {location.pathname !== "/" && (
      <Button
        variant="outlined"
        sx={{
          color: "#12538B",
          borderColor: "#12538B",
          borderRadius: "5px",
          display: "inline-flex",
          alignItems: "center",
          "&:hover": {
            borderColor: "#fff",
            backgroundColor: "#12538B",
            color: "#fff",
          },
        }}
        onClick={() => navigate(-1)}
      >
       
        {t.back}   <FaLongArrowAltLeft style={{ marginRight: "8px" }} />
      </Button>
      )}
    </Box>
  );
};

export default NotFound;
